import { useEffect, useState } from 'react';

const blockedKeys = new Set([
  'F12',
  'PrintScreen',
]);

const blockedCtrlKeys = new Set([
  'c',
  'i',
  'j',
  'p',
  's',
  'u',
  'x',
]);

function isEditableTarget(target) {
  if (!(target instanceof HTMLElement)) {
    return false;
  }

  const tagName = target.tagName.toLowerCase();
  return (
    target.isContentEditable ||
    tagName === 'input' ||
    tagName === 'textarea' ||
    tagName === 'select'
  );
}

export default function SiteProtection() {
  const [isLocked, setIsLocked] = useState(false);

  useEffect(() => {
    const blockEvent = (event) => {
      event.preventDefault();
      event.stopPropagation();
      return false;
    };

    const handleKeyDown = (event) => {
      const key = event.key.toLowerCase();
      const usesCtrl = event.ctrlKey || event.metaKey;
      const usesDevToolsCombo = event.ctrlKey && event.shiftKey && ['c', 'i', 'j'].includes(key);

      if (
        blockedKeys.has(event.key) ||
        usesDevToolsCombo ||
        (usesCtrl && blockedCtrlKeys.has(key) && !isEditableTarget(event.target))
      ) {
        blockEvent(event);
      }
    };

    const handleCopy = (event) => {
      if (!isEditableTarget(event.target)) {
        blockEvent(event);
      }
    };

    const handleDragStart = (event) => blockEvent(event);

    const detectDevTools = () => {
      const widthGap = window.outerWidth - window.innerWidth;
      const heightGap = window.outerHeight - window.innerHeight;
      setIsLocked(widthGap > 160 || heightGap > 160);
    };

    const clearConsole = window.setInterval(() => {
      console.clear();
      detectDevTools();
    }, 1000);

    detectDevTools();
    window.addEventListener('resize', detectDevTools);
    document.addEventListener('contextmenu', blockEvent, true);
    document.addEventListener('keydown', handleKeyDown, true);
    document.addEventListener('copy', handleCopy, true);
    document.addEventListener('cut', handleCopy, true);
    document.addEventListener('dragstart', handleDragStart, true);
    document.addEventListener('selectstart', handleCopy, true);

    return () => {
      window.clearInterval(clearConsole);
      window.removeEventListener('resize', detectDevTools);
      document.removeEventListener('contextmenu', blockEvent, true);
      document.removeEventListener('keydown', handleKeyDown, true);
      document.removeEventListener('copy', handleCopy, true);
      document.removeEventListener('cut', handleCopy, true);
      document.removeEventListener('dragstart', handleDragStart, true);
      document.removeEventListener('selectstart', handleCopy, true);
    };
  }, []);

  if (!isLocked) {
    return null;
  }

  return <div className="site-protection-lock" aria-hidden="true" />;
}
